module.exports = __webpack_public_path__ + "static/media/len.91e4c4d2.JPG";